export default {
  data() {
    return {
      currentPage: 1,
      reg: new RegExp('www|abler|lvh'),
      url: window.location.href,
      path: window.location.host,
      protocol: `${window.location.protocol}//`,
      pathSplit: window.location.host.split('.'),
      subdomain: window.location.host.split('.')[0],
    };
  },
  computed: {
    validateSubdomain() {
      return !!this.reg.test(this.subdomain);
    },
  },
  methods: {
    parseString: (value) => (value ? value.toString() : ''),
    isPathUrlInclude: (route) => (document.documentURI.includes(route)),
    isLastPathUrl: (route) => (document.documentURI.split('/').pop().includes(route)),
    convertCurrency: (value, brazilianCurrency) => {
      const numberVal = brazilianCurrency ? value : parseFloat(value);
      return numberVal.toLocaleString('pt-BR', { useGrouping: false, minimumFractionDigits: 2, currency: 'BRL' });
    },
    convertRSCurrencyToApi: (value) => (value.split('.').join('').replace(',', '.')),
    formatAddress: (value) => {
      const objAddress = value;
      return `
        ${objAddress.neighborhood ? objAddress.neighborhood : 'Não preenchido'}, 
        ${objAddress.city_name ? objAddress.city_name : 'Não preenchido'} - 
        ${objAddress.state_abbreviation ? objAddress.state_abbreviation : 'Não preenchido'}
      `;
    },
    getUrlParam(param) {
      return new URL(window.location.href).searchParams.get(param);
    },
    splitObjectIntoChunks: (object, size) => (
      _.chunk(
        Object.entries(object).map(([key, value]) => ({ [key]: value })), size,
      ).map(
        (objectArray) => objectArray.reduce(((r, c) => Object.assign(r, c)), {}),
      )
    ),
    replaceOrInclude: (array, reference, object) => {
      const index = _.findIndex(array, reference);

      if (index >= 0) {
        array.splice(index, 1, object);
      } else {
        array.push(object);
      }

      return array;
    },
  },
  filters: {
    truncate(string, maxLength = 15, end = '...') {
      if (!string) return '';
      string = string.toString();
      return `${string.substring(0, maxLength)}${string.length > maxLength ? end : ''}`;
    },
    capitalize(string) {
      if (!string) return '';
      string = string.toString();
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
};
